import { ComponentSingleStyleConfig } from "@chakra-ui/react";

const tabLink: ComponentSingleStyleConfig = {
  baseStyle: {
    borderBottom: "4px solid",
    fontWeight: "bold",
    borderColor: "transparent"
  },
  variants: {
    active: {
      color: "primary.500",
      borderColor: "primary.500"
    }
  }
};

export default tabLink;
